import { NavLink, useLocation, Link } from 'react-router-dom';
import { useAppSelector } from '../app/hooks';
import { WorkspaceSwitcher } from './WorkspaceSwitcher';

const EmployeeSidebar = () => {
    const isSidebarOpen = useAppSelector((state) => state.ui.isSidebarOpen);
    const location = useLocation();
    const user = useAppSelector((state) => state.auth.user);

    const navItems = [
        {
            section: 'Home',
            items: [
                {
                    name: 'Dashboard', path: '/ess/dashboard', icon: (
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" /></svg>
                    )
                },
                {
                    name: 'Colleagues', path: '/ess/colleagues', icon: (
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" /></svg>
                    )
                },
            ]
        },
        {
            section: 'My Work',
            items: [
                {
                    name: 'Attendance', path: '/ess/attendance', icon: (
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                    )
                },
                {
                    name: 'Time Off', path: '/ess/leaves', icon: (
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" /></svg>
                    )
                },
                {
                    name: 'Calendar', path: '/ess/calendar', icon: (
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M19 4H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V6a2 2 0 00-2-2zM16 2v4M8 2v4M3 10h18" /></svg>
                    )
                },
                {
                    name: 'Apply Leave', path: '/ess/leave/apply', icon: (
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M12 11v6m3-3h-6" />
                        </svg>
                    )
                },
            ]
        },
        {
            section: 'Money',
            items: [
                {
                    name: 'My Payslips', path: '/ess/payslips', icon: (
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M9 14l6-6m-5.5.5h.01m4.99 5h.01M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16l3.5-2 3.5 2 3.5-2 3.5 2z" /></svg>
                    )
                },
                {
                    name: 'Salary Advance', path: '/ess/advance-request', icon: (
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                    )
                },
            ]
        },
        {
            section: 'Me',
            items: [
                {
                    name: 'My Profile', path: '/ess/profile', icon: (
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" /></svg>
                    )
                },
                {
                    name: 'My Documents', path: '/ess/documents', icon: (
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z" /></svg>
                    )
                },
                {
                    name: 'Requests', path: '/ess/requests', icon: (
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" /></svg>
                    )
                },
            ]
        },
    ];

    return (
        <aside
            className={`fixed inset-y-0 left-0 z-30 w-72 bg-gradient-to-b from-slate-900 via-slate-900 to-slate-800 transform transition-transform duration-300 ease-in-out lg:translate-x-0 lg:static lg:inset-0 flex flex-col ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full'
                }`}
        >
            {/* Logo */}
            <div className="flex-shrink-0 flex items-center gap-3 px-7 h-20 border-b border-white/5">
                <div className="h-10 w-10 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-xl flex items-center justify-center shadow-lg shadow-indigo-500/20">
                    <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M13 10V3L4 14h7v7l9-11h-7z" />
                    </svg>
                </div>
                <div>
                    <span className="text-white text-lg font-bold tracking-tight">noor<span className="text-indigo-400">HR</span></span>
                    <p className="text-[10px] text-slate-500 font-semibold uppercase tracking-widest">Employee Portal</p>
                </div>
            </div>

            {/* Workspace Switcher */}
            <div className="mt-4">
                <WorkspaceSwitcher theme="dark" isCollapsed={false} />
            </div>

            {/* User Mini Card */}
            <div className="mx-5 mt-6 mb-2 p-4 bg-white/5 rounded-2xl border border-white/5">
                <div className="flex items-center gap-3">
                    <div className="h-10 w-10 rounded-full bg-gradient-to-br from-indigo-500 to-purple-500 flex items-center justify-center text-white font-bold text-sm shadow-md">
                        {user?.firstName?.charAt(0)}{user?.lastName?.charAt(0)}
                    </div>
                    <div className="min-w-0">
                        <p className="text-sm font-semibold text-white truncate">{user?.firstName} {user?.lastName}</p>
                        <p className="text-[11px] text-slate-400 font-medium truncate">{user?.email}</p>
                    </div>
                </div>
            </div>

            {/* Navigation */}
            <nav className="mt-4 px-4 space-y-6 flex-1 overflow-y-auto no-scrollbar pb-6">
                {navItems.map((section) => (
                    <div key={section.section}>
                        <p className="px-3 mb-2 text-[10px] font-bold text-slate-500 uppercase tracking-[0.2em]">
                            {section.section}
                        </p>
                        <div className="space-y-1">
                            {section.items.map((item) => (
                                <NavLink
                                    key={item.name}
                                    to={item.path}
                                    className={({ isActive }) =>
                                        `flex items-center px-3 py-2.5 rounded-xl transition-all duration-200 group ${isActive
                                            ? 'bg-indigo-500/15 text-indigo-400 font-semibold shadow-sm shadow-indigo-500/5'
                                            : 'text-slate-400 hover:bg-white/5 hover:text-white'
                                        }`
                                    }
                                >
                                    <span className={`transition-transform duration-200 group-hover:scale-110 ${location.pathname === item.path ? 'scale-110' : ''}`}>
                                        {item.icon}
                                    </span>
                                    <span className="ml-3 text-sm">{item.name}</span>
                                    {location.pathname === item.path && (
                                        <div className="ml-auto h-1.5 w-1.5 rounded-full bg-indigo-400 animate-pulse" />
                                    )}
                                </NavLink>
                            ))}
                        </div>
                    </div>
                ))}
            </nav>

            {/* Dashboard Switch Toggle */}
            {['hr_admin', 'admin', 'super_admin', 'hr'].includes(user?.role?.toLowerCase() || '') && (
                <div className="px-5 mb-5">
                    <Link
                        to="/dashboard"
                        className="group flex items-center justify-center gap-3 p-4 rounded-2xl bg-white/5 border border-white/10 hover:border-indigo-500/30 transition-all duration-300"
                    >
                        <div className="h-8 w-8 bg-indigo-500/20 rounded-xl flex items-center justify-center text-indigo-400 group-hover:bg-indigo-500 group-hover:text-white transition-all duration-300">
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" /></svg>
                        </div>
                        <div className="flex-1 min-w-0">
                            <p className="text-[11px] font-black text-indigo-400 uppercase tracking-widest">Admin Dashboard</p>
                            <p className="text-[9px] text-slate-500 font-bold opacity-70">Switch to management</p>
                        </div>
                    </Link>
                </div>
            )}

            {/* Footer Help */}
            <div className="flex-shrink-0 mx-5 mb-5 p-4 bg-gradient-to-r from-indigo-600/20 to-purple-600/20 rounded-2xl border border-indigo-500/10">
                <div className="flex items-center gap-3">
                    <div className="h-8 w-8 bg-indigo-500/20 rounded-lg flex items-center justify-center flex-shrink-0">
                        <svg className="w-4 h-4 text-indigo-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                    </div>
                    <div>
                        <p className="text-xs font-semibold text-white">Need help?</p>
                        <p className="text-[10px] text-slate-400 font-medium">Contact HR support</p>
                    </div>
                </div>
            </div>
        </aside>
    );
};

export default EmployeeSidebar;
